import React from 'react';
import PropTypes from 'prop-types';

import { MUIModal } from 'Components/Base';

import ClearCompleteContent from './ClearCompleteContent';

const ClearCompleteModal = ({
  onBackToClassroom,
  onGoToClearSite,
  isOpen,
  toggleComponent,
  onOpenModal,
  onCloseModal,
  ...props
}) => {
  return (
    <MUIModal
      isOpen={isOpen}
      toggleComponent={toggleComponent}
      onOpenModal={onOpenModal}
      onCloseModal={onCloseModal}
      modalStyle={{ padding: '36px', borderRadius: '16px', maxWidth: '343px', height: '410px' }}
      innerProps={{ height: '100%' }}
      closeIcon={false}
      disableBackdropClick
      {...props}
    >
      <ClearCompleteContent
        onBackToClassroom={onBackToClassroom}
        onGoToClearSite={onGoToClearSite}
      />
    </MUIModal>
  );
};

ClearCompleteModal.propTypes = {
  toggleComponent: PropTypes.element,
  onOpenModal: PropTypes.func,
  onCloseModal: PropTypes.func,
  isOpen: PropTypes.bool,
  onBackToClassroom: PropTypes.func,
  onGoToClearSite: PropTypes.func,
};

export default ClearCompleteModal;
